// ServicesSection.tsx
import React from "react";
import { Service } from "./types";

interface ServicesSectionProps {
  services: Service[];
  selectedService: Service | null;
  onSelectService: (service: Service) => void;
}

const ServicesSection: React.FC<ServicesSectionProps> = ({
  services,
  selectedService,
  onSelectService,
}) => {
  function convertirMinutos(minutos: number): string {
    if (minutos < 0) {
      throw new Error("El número de minutos no puede ser negativo");
    }

    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;

    const partes: string[] = [];

    if (horas > 0) {
      partes.push(`${horas} hora${horas !== 1 ? "s" : ""}`);
    }

    if (minutosRestantes > 0) {
      partes.push(
        `${minutosRestantes} minuto${minutosRestantes !== 1 ? "s" : ""}`
      );
    }

    if (partes.length === 0) {
      return "0 minutos";
    }

    return partes.join(" y ");
  }
  return (
    <section id="services">
      <h2>Servicios Disponibles</h2>
      <p>Selecciona el servicio por el que deseas agendar tu cita.</p>

      <ul className="service-list">
        {services.map((service) => (
          <li
            key={service.id}
            className={`service-item ${
              selectedService?.id === service.id ? "selected-step" : ""
            }`}
            onClick={() => onSelectService(service)}
          >
            <h4>{service.name}</h4>
            <p>{service.description}</p>
            <p>{convertirMinutos(service.duration)}</p>
            <p style={{ fontWeight: 700 }}>${service.price.toFixed(2)}</p>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ServicesSection;
